export const cleanInputs = () => {
    document.getElementById('client_name').value = '';
    document.getElementById('client_identification').value = '';
    document.getElementById('client_address').value = '';
    document.getElementById('client_cod').value = '';
    document.getElementById('client_email_market').value = '';
    document.getElementById('client_email_account').value = '';
    document.getElementById('client_email_invoice').value = '';
}

export const buildCreateClientBody = (company) => {
    return {
        name: document.getElementById('client_name').value,
        identification: document.getElementById('client_identification').value,
        address: document.getElementById('client_address').value,
        cod: document.getElementById('client_cod').value,
        seller: document.getElementById('client_seller').value,
        email_market: document.getElementById('client_email_market').value,
        email_account: document.getElementById('client_email_account').value,
        email_invoice: document.getElementById('client_email_invoice').value,
        city: document.getElementById('client_city').value,
        special: document.getElementById('ean').checked ? 1 : 0,
        company
    }
}

export const validateCreateClient = (body) => {
    if(body.name === null || body.name === ''){
        throw new Error('Razón social vacía');
    }

    if(body.identification === null || body.identification === ''){
        throw new Error('NIT vacío');
    }

    if(body.address === null || body.address === ''){
        throw new Error('Dirección vacía');
    }

    if(body.cod === null || body.cod === ''){
        throw new Error('Referencia vacía');
    }

    if(body.email_invoice === null || body.email_invoice === ''){
        throw new Error('Correo de facturación vacío');
    }

    if(body.seller === null || body.seller === ''){
        throw new Error('Vendedor asociado vacío');
    }

    if(body.city === null || body.city === ''){
        throw new Error('Ciudad vacía');
    }
}